"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }


var _smsParts = require('./smsParts');







































const ALL_PLATFORMS = ['web', 'desktop', 'mobile']
const EVERYONE = ['staff', 'patient']
const SECTION_ORDER = ['insert', 'send', 'more']

 const SCHEDULING_FILES_UNSUPPORTED = "Scheduling files isn't supported yet"; exports.SCHEDULING_FILES_UNSUPPORTED = SCHEDULING_FILES_UNSUPPORTED
// A long plain SMS goes as numbered texts (smsParts); scheduled ones aren't split.
 const SCHEDULED_TEXT_TOO_LONG = 'Scheduled texts must fit in one text (1,600 characters).'; exports.SCHEDULED_TEXT_TOO_LONG = SCHEDULED_TEXT_TOO_LONG
 const FORM_NEEDS_ONE_PATIENT = 'Forms go to a chat with one patient.'; exports.FORM_NEEDS_ONE_PATIENT = FORM_NEEDS_ONE_PATIENT

 const BUILT_IN_COMPOSER_ACTIONS = [
  {
    id: 'attach',
    label: 'Attach',
    icon: 'attach',
    section: 'insert',
    shortcut: { key: 'u', mod: true },
    platforms: ALL_PLATFORMS,
    roles: EVERYONE,
  },
  {
    id: 'emoji',
    label: 'Emoji',
    icon: 'emoji',
    section: 'insert',
    shortcut: { key: 'e', mod: true },
    platforms: ALL_PLATFORMS,
    roles: EVERYONE,
  },
  // Opens Send later, for staff only. Text only for now: files in the tray
  // grey it out. Templates is lane D's to register.
  {
    id: 'schedule',
    label: 'Schedule…',
    icon: 'schedule',
    section: 'send',
    shortcut: { key: 'Enter', mod: true, shift: true },
    platforms: ALL_PLATFORMS,
    isEnabled: ctx => {
      if (ctx.sendGate.blocked) return ctx.sendGate.reason || ''
      if (ctx.hasFiles) return exports.SCHEDULING_FILES_UNSUPPORTED
      if (ctx.channel === 'sms' && (_nullishCoalesce(ctx.textLength, () => ( 0))) > _smsParts.SMS_PART_LENGTH) return exports.SCHEDULED_TEXT_TOO_LONG
      return ctx.hasText ? true : ''
    },
  },
  // Sends one of the org's published forms to the chat's patient, in a
  // patient chat. Each platform supplies its handler only when the org has
  // Forms. The server refuses a chat with more than one patient, so the menu
  // says so up front.
  {
    id: 'sendForm',
    label: 'Send a form…',
    icon: 'form',
    section: 'send',
    platforms: ALL_PLATFORMS,
    isVisible: ctx => (_nullishCoalesce(ctx.patientCount, () => ( 0))) > 0,
    isEnabled: ctx => ctx.patientCount === 1 ? true : exports.FORM_NEEDS_ONE_PATIENT,
  },
]; exports.BUILT_IN_COMPOSER_ACTIONS = BUILT_IN_COMPOSER_ACTIONS

// Later registrations of an id shadow earlier ones; unregistering one uncovers
// the previous, so a test or a feature can override a built-in and put it back.
let registrations = [...exports.BUILT_IN_COMPOSER_ACTIONS]

 const registerComposerAction = (action) => {
  registrations = [...registrations, action]
  return () => {
    registrations = registrations.filter(registered => registered !== action)
  }
}; exports.registerComposerAction = registerComposerAction

const currentActions = () => {
  const latestById = new Map()
  registrations.forEach(action => latestById.set(action.id, action))
  // Keep the order an id was first registered in.
  const firstSeen = []
  registrations.forEach(action => {
    if (!firstSeen.includes(action.id)) firstSeen.push(action.id)
  })
  return firstSeen.map(id => latestById.get(id))
}

const isShown = (action, ctx) =>
  action.platforms.includes(ctx.platform)
  && (action.roles || ['staff']).includes(ctx.role)
  && (action.isVisible ? action.isVisible(ctx) : true)

// The actions to show, by section, then in registration order.
 const getComposerActions = (ctx) => {
  const shown = currentActions().filter(action => isShown(action, ctx))
  return SECTION_ORDER.flatMap(section => shown.filter(action => action.section === section))
}; exports.getComposerActions = getComposerActions






// A disabled composer gives no reason: that state carries no text.
 const composerActionState = (action, ctx) => {
  if (ctx.disabled) return { enabled: false }
  const result = action.isEnabled ? action.isEnabled(ctx) : true
  if (result === true) return { enabled: true }
  return result ? { enabled: false, reason: result } : { enabled: false }
}; exports.composerActionState = composerActionState
